// core
import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'open-raptor-sidebar',
  templateUrl: './raptor-sidebar.component.html',
  styleUrls: ['./raptor-sidebar.component.scss']
})
export class RaptorSidebarComponent implements OnInit, OnDestroy {
  @Input() sidebar: any;
  @Input() form: any;
  @ViewChild('container') container!: ElementRef<HTMLInputElement>;

  collapsed: boolean = true;

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }


  public toggleView() {
    this.collapsed = !this.collapsed;
    document.body.classList.toggle("body-no-scroll");
  }


}
